export var noIdLeaguesToMedals = {
    coopLeagueMedal: "player-profile-medal__coop-locked",
    playerLeagueMedal: "player-profile-medal__player-locked",
};
export var getMedalByIdLeagues = function (idLeague) {
    return getMedalByMedalType(Math.floor(idLeague));
};
var getMedalByMedalType = function (medalType) {
    return {
        coopLeagueMedal: "player-profile-medal__coop-" + medalType,
        playerLeagueMedal: "player-profile-medal__player-" + medalType,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/mapIdLeaguesToMedals.ts
// module id = 2873
// module chunks = 3